/**
 * Shared presentation helpers for the video library UI.
 */

/**
 * Turn "16:9" into a CSS aspect-ratio value. Falls back to 16/9.
 */
export const cssAspectRatio = (aspectRatio) => {
  if (typeof aspectRatio === 'string' && /^\d+:\d+$/.test(aspectRatio.trim())) {
    const [w, h] = aspectRatio.trim().split(':').map(Number);
    if (w > 0 && h > 0) return `${w} / ${h}`;
  }
  return '16 / 9';
};

/**
 * Product-facing model names: the Gemini Omni Flash family ships as "Google Omni".
 */
export const prettyModelLabel = (label, alias) => {
  const base = label || alias || 'Unknown model';
  return base.replace(/Gemini Omni Flash/gi, 'Google Omni');
};
